export const PLATFORM = Object.freeze({
  name: 'Pool 4 Real',
  shortName: 'P4R',
  siteUrl: 'https://pool4real.com',
  supportEmail: process.env.REACT_APP_SUPPORT_EMAIL || 'support@pool4real.com',
  ios: Object.freeze({
    name: 'iPhone',
    status: 'AVAILABLE',
    appId: '6502504942',
    url: process.env.REACT_APP_IOS_STORE_URL || 'https://apps.apple.com/us/app/pool-4-real/id6502504942',
  }),
  android: Object.freeze({
    name: 'Android',
    status: 'AVAILABLE',
    packageName: 'com.pool4real.p4r',
    url:
      process.env.REACT_APP_ANDROID_STORE_URL ||
      'https://play.google.com/store/apps/details?id=com.pool4real.p4r',
  }),
});

export const PUBLIC_ROUTES = Object.freeze([
  '/',
  '/download',
  '/find-pool-players-near-me',
  '/pool-tournaments-near-me',
  '/pool-halls-near-me',
  '/pool-scorekeeper',
  '/pool-practice-room',
  '/pool-match-tracker',
  '/organize-pool-matches',
  '/pool-teams',
  '/pool-hall-management',
  '/buy-sell-pool-equipment',
  '/billiards-community',
  '/feed',
  '/players',
  '/map',
  '/teams',
  '/tournaments',
  '/race-room',
  '/shoparound',
]);
